module.exports = __webpack_public_path__ + "static/media/icon.07062593.png";